import React, { useContext } from 'react'
import { FlexView, Button, Icon } from 'components/common'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
import { TubularContext } from 'stores/TubularStore'

const BackButtons = styled(Button)`
  border-radius: 56%;
  width: 40px;
  height: 40px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // margin: 0px;
`
// const Span = styled.span`
//   border-radius: 10px;
//   font-size: 20px;
//   line-height: 30px;
//   font-weight: bolder;
//   margin: 13px 12px!important;
// `
const SpanInvoice = styled.span`
  border-radius: 10px;
  margin: 15px 0px!important;
  font-size: 20px;
  line-height: 30px;
  font-weight: bolder;
  color: ${({ theme }) => theme.colors.secondary};
  margin: 13px 10px!important;
`

const SubHeader = ({ title, value }) => {
  // const { t } = useTranslation()
  const { setSearchResult } = useContext(TubularContext)
  const back = () => {
    setSearchResult(0)
    history.goBack()
  }

  const history = useHistory()

  const content = <FlexView flexDirection='row' alignSelf="stretch" width='2300px' style={{ maxWidth: "90%", marginLeft:'4%' }}>
    <BackButtons outline color="#f4f4f4" onClick={() => back()}>
      <Icon tooltip="Left" tooltipPosition="left" name="arrow-left" width="15px" height="15px" />
    </BackButtons>
    {/* <Span>
      {title}
    </Span> */}
    <SpanInvoice>
      {value}
    </SpanInvoice>
    {/* <Button  fontSize="tiny" onClick={back} color="secondary" outline >{t('tlh.close')}</Button> */}
  </FlexView>
  return content
}
export default SubHeader